export enum PackageType {
  FREE = 'free',
  PREMIUM = 'premium',
}
